import React from 'react';
import PhoneMockup from './PhoneMockup';
import PlayStoreIcon from './PlayStoreIcon';
import { Wand2, Sparkles, Image, Video } from 'lucide-react';

export default function Hero() {
  return (
    <section className="relative pt-12 pb-24 px-6 overflow-hidden max-w-7xl mx-auto">
      {/* Decorative gradient glowing orb */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[#E63946]/10 rounded-full blur-3xl pointer-events-none -z-10" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div className="flex flex-col gap-6 text-center md:text-left">
          <div className="inline-flex items-center gap-2 bg-[#161B26] border border-gray-800 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold w-fit mx-auto md:mx-0">
            <Sparkles className="w-4 h-4 text-[#E63946]" />
            <span className="text-gray-300">Next-Gen Media Studio</span>
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight text-white">
            Photo &amp; Video Editing Made <span className="text-[#E63946]">Effortlessly Easy</span>
          </h1>

          <p className="text-gray-400 text-base md:text-lg max-w-xl mx-auto md:mx-0 leading-relaxed">
            Ditch complex timeline editing and complicated color tools. With PFP AI, just type your instructions to instantly generate art, enhance clarity, try stunning hairstyles, or transform video lighting on the fly.
          </p>

          {/* Interactive UI Mockup instruction bar */}
          <div className="bg-[#121622] border border-gray-800/80 rounded-2xl p-2.5 flex items-center gap-3 shadow-xl max-w-xl mx-auto md:mx-0 w-full focus-within:border-[#E63946]/40 transition-colors">
            <Wand2 className="w-5 h-5 text-[#E63946] shrink-0 ml-2" />
            <input
              type="text"
              readOnly
              placeholder="e.g., 'Turn portrait into a hyper-detailed cyberpunk look'"
              className="bg-transparent border-none text-xs md:text-sm text-gray-200 w-full focus:outline-none truncate pointer-events-none"
            />
            <div className="bg-[#E63946] text-white px-4 py-2 rounded-xl text-xs font-bold shrink-0 shadow-md">
              Generate
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 pt-2">
            <a 
              href="https://play.google.com/store/apps/details?id=com.pfpaiapp&pcampaignid=web_share" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-block focus:outline-none"
            >
              <PlayStoreIcon className="h-40 md:h-40 w-auto" />
            </a>

            <div className="flex items-center gap-6 px-4 py-2 text-gray-400 text-xs font-semibold border-l border-gray-800">
              <div className="flex items-center gap-1.5">
                <Image className="w-4 h-4 text-[#F6D365]" /> Photos
              </div>
              <div className="flex items-center gap-1.5">
                <Video className="w-4 h-4 text-[#E63946]" /> Videos
              </div>
            </div>
          </div>
        </div>

        <div className="relative">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
}
